export const LISTE_PRODUIT_RESEAU_TEMPO_DISPO = {
  title: 'Liste des réseaux temporaires disponibles',
  breadcrumb: {
    racine: 'Accueil',
    liste: 'Liste des réseaux temporaires disponibles',
  },
  actions: {
    search: 'Rechercher',
    brief: 'Brief',
    panier: 'Panier',
  },
  tabs: {
    reference: 'Référence',
    libelle: 'Libellé',
    ville: 'Ville',
    format: 'Format',
    type: 'Type',
    nbFacesPrevues: 'Nb faces prévues',
    nbFacesReelles: 'Nb faces réelles',
    societe: 'Société',
    agence: 'Agence',
  },
  brief: {
    title: 'Mon brief',
    sousTitle: 'Appliquer les paramètres de votre brief',
    dateVisualisation: 'Date de visualisation',
    reference: 'Référence',
    libelle: 'Libellé',
    ville: 'Ville(s)',
    departement: 'Département(s)',
    format: 'Format(s)',
    type: 'Type(s) de réseau',
    societe: 'Société',
    reseauConfrere: 'Inclure réseaux confrères',
    errors: {
      dateVisualisation: 'La date de visualisation est obligatoire',
    },
    actions: {
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
  },
  panier: {
    title: 'Panier',
    sousTitle: '{numberProduit} produit(s) dans votre panier',
    actions: {
      parametrer: 'Paramétrer ma sélection',
      clearSelection: 'Vider la sélection',
    },
    panierVide: 'Votre panier est vide',
    noProduct: 'Sélectionnez des produits',
  },
};

export const POP_UP_PARAMETRAGE_RESEAU_DISPO = {
  title: 'Paramétrage des réseaux disponibles',
  titleRecap: 'Récapitulatif des réseaux disponibles',
  actions: {
    cancel: 'Annuler',
    nextStep: 'Etape suivante',
    beforeStep: 'Etape précédente',
    export: 'Exporter',
    createDevis: 'Créer un devis',
  },
  location: 'Location',
  niveauDeDispo: 'Niveau de disponibilité',
  errors: {
    problemOccurred: 'Un problème est survenu',
    excelError: 'Problème lors de la génération du fichier excel',
    produitLoc: 'Le produit de location est obligatoire',
    weeksSelect: 'Veuillez sélectionner au moins une semaine',
    lignesCommande: 'Veuillez avoir au moins un réseau disponible dans votre récapitulatif',
    reseauTempoWithoutDefautProduit: 'Le produit \'{libelle}\' n\'a pas de produit de location par défaut',
    excelExportErrorNoReseau: 'Impossible d\'exporter le fichier : aucun réseau disponible dans votre récapitulatif',
  },
  sucess: {
    creationExcel: 'Le fichier excel a été généré avec succès.',
  },
  excelInfo: {
    title: 'Réseaux tempo disponibles',
    filename: 'Réseaux tempo dispo.xlsx',
  },
  etatSouhaite: 'Etat souhaité',
  tab: {
    reference: 'Référence',
    libelle: 'Libellé',
    ville: 'Ville',
    format: 'Format',
    facePrevues: 'F. prév.',
    faceReelles: 'F. réelles',
    depart: 'Départ',
    tarif: 'Tarif',
    taxe: 'Taxe',
    frais: 'Frais',
    etat: 'Etat',
    resteAVendre: 'Reste à vendre',
    departement: 'Département',
    semaine: 'Semaine',
    annee: 'Année',
  },
};
